import React from 'react';

const Minus = () => (
  <svg width="16" height="3" viewBox="0 0 16 3" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1.82349H16" stroke={'currentColor'} strokeWidth="2" />
  </svg>
);

export default Minus;
